import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 施設等新設届参照
// API仕様書_申請情報
import {
  IAPI_APP003_Request,
  IAPI_APP003_Response,
} from "../../../type/apiType";

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 施設等新設届参照
// API仕様書_申請情報
const httpIAPI_APP003 = async (
  param: IAPI_APP003_Request
): Promise<IAPI_APP003_Response> => {
  let res = await http.post(ApiUrl.API_APP003, {
    ...param,
  });
  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpIAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_APP003, httpIAPI_APP016 };
